import { render, staticRenderFns } from "./MyProductsServices.vue?vue&type=template&id=044bd60e&scoped=true"
import script from "./MyProductsServices.vue?vue&type=script&lang=js"
export * from "./MyProductsServices.vue?vue&type=script&lang=js"
import style0 from "./MyProductsServices.vue?vue&type=style&index=0&id=044bd60e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044bd60e",
  null
  
)

export default component.exports